import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';
import { refreshEventDetailQueries } from './refresh-event-detail-queries';

/** DELETE /admin/events/:eventId/attendees/:attendeeId */
export const useDeleteEventAttendeeMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    ...restOptions,
    meta: { handleErrorLocally: true, ...restOptions.meta },
    mutationFn: async ({ eventId, attendeeId }) => {
      if (!api.deleteEventAttendee) {
        throw new Error('Removing attendees is not available for this account');
      }

      const result = await api.deleteEventAttendee(eventId, attendeeId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to remove attendee');
      }

      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (variables?.eventId) {
        await refreshEventDetailQueries(queryClient, variables.eventId);
      }
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
  });
};
